/** The blue-ish look shared by the walkthrough popup and pointer. */
export const walkthroughColors = {
  background: '#EAF3FC',
  border: '#9DC3EA',
  text: '#0B3A66',
  /** Outline drawn around the element a step points at. */
  highlight: '#2F7FD8'
} as const;

export const walkthroughPaperSx = {
  bgcolor: walkthroughColors.background,
  color: walkthroughColors.text,
  border: `1px solid ${walkthroughColors.border}`,
  borderRadius: 2
} as const;
